/** Visitors who signal "do not track" or Global Privacy Control are not counted at all (funnel counters and analytics events). */
export function funnelOptedOut(): boolean {
  try {
    const n = navigator as Navigator & { globalPrivacyControl?: boolean };
    return n.doNotTrack === "1" || n.globalPrivacyControl === true;
  } catch {
    return false;
  }
}
